<template>
  <!-- style="position: relative; top:-50px;" -->
  <v-content>
    <v-stepper
      v-model="stepper"
      style="box-shadow: none;" 
    >
      <v-stepper-items>
        <v-row
          justify="center"
          no-gutters
        >
          <v-col
            class="my-4 pa-0"
            cols="12"
          >

        <!---------------------------------------------------------------------->
        <!--------------------   What can we plan for you   -------------------->
        <!--------------------            STEP 1            -------------------->
        <!---------------------------------------------------------------------->

            <v-stepper-content
              step="1"
              class="pa-0 ma-0"
            >
              <step1/>
            </v-stepper-content>

        <!--------------------------------------------------------------------->
        <!--------------------     Who are we feeding?     -------------------->
        <!--------------------            STEP 2           -------------------->
        <!--------------------------------------------------------------------->
            <v-stepper-content
              step="2"
              class="pa-0 ma-0"
            >
              <step2/>
            </v-stepper-content>

        <!--------------------------------------------------------------------->
        <!--------------------Let's Personalize Your Plans -------------------->
        <!--------------------            STEP 3           -------------------->
        <!--------------------------------------------------------------------->
            <v-stepper-content
              step="3"
              class="pa-0 ma-0"
            >
              <step3/>
            </v-stepper-content>

        <!--------------------------------------------------------------------->
        <!--------------------        Create Account       -------------------->
        <!--------------------            STEP 4           -------------------->
        <!--------------------------------------------------------------------->
            <v-stepper-content
              step="4"
              class="pa-0 ma-0"
            >
              <step4/>
            </v-stepper-content>

        <!--------------------------------------------------------------------->
        <!--------------------         Verify Email        -------------------->
        <!--------------------            STEP 5           -------------------->
        <!--------------------------------------------------------------------->
            <v-stepper-content
              step="5"
              class="pa-0 ma-0"
            >
              <step5/>
            </v-stepper-content>

        <!--------------------------------------------------------------------->
        <!--------------------     Payment Information     -------------------->
        <!--------------------            STEP 6           -------------------->
        <!--------------------------------------------------------------------->
            <v-stepper-content
              step="6"
              class="pa-0 ma-0"
            >
              <step6/>
            </v-stepper-content>


        <!--------------------------------------------------------------------->
        <!--------------------  Already have an account?   -------------------->
        <!--------------------------------------------------------------------->
            <v-row
              v-if="!signedIn && stepper != 6"
              class="mt-5"
              justify="center"
              no-gutters
            >
              Already have an account?
            </v-row>
            <v-row
              v-if="!signedIn && stepper != 6"
              class="mb-5"
              justify="center"
              no-gutters
            >
              <v-dialog
                v-model="authDialog"
                persistent
                width="500"
              >
                <template
                    v-slot:activator="{ on }"
                >
                  <a
                      @click.prevent="openAuthDialog"
                      v-on="on"
                    >
                      Sign In
                    </a>
                </template>
                <v-card
                  style="overflow-x: hidden; overflow-y: hidden"
                  class="ma-0 pa-0"
                >                   
                  <v-row
                    no-gutters
                  >
                    <v-btn
                      absolute
                      small
                      fab
                      top
                      right
                      @click="closeAuthDialog"
                      class="mt-8"
                    >
                      <v-icon>
                        close
                      </v-icon>
                    </v-btn>
                    <v-col
                      class="ma-0 pa-0"
                    >
                      <Authorization/>
                    </v-col>
                  </v-row>
                </v-card>
              </v-dialog>
            </v-row>

          </v-col>
        </v-row>
      </v-stepper-items>
    </v-stepper>

  </v-content>
</template>

<script>
  import Authorization from '@/components/login/Auth.vue'
  import step1 from '@/components/signup/step1.vue'
  import step2 from '@/components/signup/step2.vue'
  import step3 from '@/components/signup/step3.vue'
  import step4 from '@/components/signup/step4.vue'
  import step5 from '@/components/signup/step5.vue'
  import step6 from '@/components/signup/step6.vue'

export default {
  components: {
    Authorization,
    step1,
    step2,
    step3,
    step4,
    step5,
    step6
  },

  data: () => ({
    processingSubmit: false,  //not currently being used, but should be to display processing of email confirmation
  }),
  
  mounted () {
    if(this.$store.getters['data/diets'].length == 0) {
      this.$store.dispatch('data/loadSignUpData')
    }
  },

  methods: {
    openAuthDialog() {
      this.$store.dispatch('login/currentAuthView',"SignIn");
      this.$store.dispatch('login/authDialog',true);
    },

    closeAuthDialog() {
      this.$store.dispatch('login/authDialog',false);
      this.$store.dispatch('login/currentAuthView',"SignIn");
      this.$store.dispatch('login/updateUsername',null);
      this.$store.dispatch('login/showConfirmUser',false);
    },

  },

  computed: {
    authDialog() {
      return this.$store.getters['login/authDialog'];
    },

    stepper: {
      get() {
        return this.$store.getters['data/stepper'];
      },
      set(value) {
        this.$store.dispatch('data/updateStepper',value)
      }
    },

    signedIn() {
      return this.$store.getters['login/signedIn'];
    },
    
  }
}
</script>

<style>
  .bg5 {
    background: url(../assets/main/background5.png);
    background-size: cover;
    padding: 40px 20px 30px 20px;
  }
</style>

<style scoped>
  .btn2 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.9em;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }

  .btn3 {
    font-size: 0.9em;
    width: 100%;
    min-height: 48px;
    font-weight: 400;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: #74cf74 !important;
    font-weight: 600;
  }
</style>